const EMPTY_SEARCH_WHITELIST = {
  contests: true,
  events: true,
  videos: true,
};

export default function shouldAllowEmptySearchQuery(algoliaIndex) {
  return EMPTY_SEARCH_WHITELIST[algoliaIndex] || false;
}
